import { useState } from 'react';
import React from 'react';
import EnableNotification from '../component/coinpopup/EnableNotification';
import { Drama as SliderDrama } from '../component/Slider';
import { useCoinStore } from '../store/coinstore';
import { addCoinData } from '../utils/coinApi';
import { getCurrentServerTime } from '../utils/serverTime';
import { Config } from './config';
import style from './page.module.css';
import { useRouter } from 'next/navigation';
import { ShareModal } from '../component/socialshare/ShareModal';
import { useShareModalStore } from '../store/localapi';

export default function TaskList({ onAward, values }: { onAward: (amt: number) => void, values: Config }) {
    const coins = useCoinStore((state) => state.coinBalance);
    const setCoin = useCoinStore.getState().setCoinBalance;
    const router = useRouter();
    const [notifyEnabled, setNotifyEnabled] = useState(false); // Never auto-open popup
    const [showShareModal, setShowShareModal] = useState(false);
    const [hasShared, setHasShared] = useState(false);
    const [showSharePopup, setShowSharePopup] = useState(false);
    const { openShareModal } = useShareModalStore();

    // Reset daily rewards when date changes (based on server time)
    React.useEffect(() => {
        const today = getCurrentServerTime().toISOString().split('T')[0];
        const storedDate = coins.watchDurationDate;
        
        // Reset if date changed
        if (storedDate && storedDate !== today) {
            setCoin({
                watchDuration: 0,
                watchDurationDate: today,
                is10: "0",
                is20: "0"
            });
        }
    }, []);

    // When notification modal opens, immediately prompt for permission if still in default state
    React.useEffect(() => {
        const maybePrompt = async () => {
            if (!notifyEnabled) return;
            if (typeof window === 'undefined' || typeof Notification === 'undefined') return;
            if (Notification.permission === 'default') {
                try {
                    const perm = await Notification.requestPermission();
                    if (perm !== 'granted') {
                        // Close popup if user denies/dismisses
                        setNotifyEnabled(false);
                    }
                } catch {
                    setNotifyEnabled(false);
                }
            }
        };
        maybePrompt();
    }, [notifyEnabled]);

    const renderButton = (state: string, onGo?: () => void, onClaim?: () => void) => {

        const claimedClass = state === 'claimed' ? style.dfx_Claimed : '';
        if (state === 'go') {
            return (
                <div className={`${style.dfx_Check_InBtn} ${claimedClass}`}>
                    <button className="commonBtn" onClick={onGo}>Go</button>
                </div>
            );
        }
        if (state === 'claim') {
            return (
                <div className={`${style.dfx_Check_InBtn} ${claimedClass}`}>
                    <button className="commonBtn" onClick={onClaim}>Claim</button>
                </div>
            );
        }
        if (state === 'share') {
            return (
                <div className={`${style.dfx_Check_InBtn} ${claimedClass}`}>
                    <button className="commonBtn" onClick={onGo}>Share</button>
                </div>
            );
        }
        return (
            <div className={`${style.dfx_Check_InBtn} ${claimedClass}`}>
                <button className="commonBtn" disabled>Claimed</button>
            </div>
        );
    };

    const is10btn = () => {
        if (coins.is10 === "2") {
            return 'claimed';
        } else if (coins.is10 === "1" && coins.watchDuration >= 600) {
            // Production: 600s (10 minutes)
            return 'claim';
        } else {
            return 'go';
        }
    }

    const is20btn = () => {
        if (coins.is20 === "2") {
            return 'claimed';
        } else if (coins.is20 === "1" && coins.watchDuration >= 1200) {
            // Production: 1200s (20 minutes)
            return 'claim';
        } else {
            return 'go';
        }
    }

    const socialbtn = (key: string) => {
        const k = key as string;
        if (k === 'youtube' && coins.yt === "2") {
            return 'claimed';
        } else if (k === 'youtube' && coins.yt == "1") {
            return 'claim';
        }
        if (k === 'facebook' && coins.fb === "2") {
            return 'claimed';
        } else if (k === 'facebook' && coins.fb == "1") {
            return 'claim';
        }
        if (k === 'instagram' && coins.insta === "2") {
            return 'claimed';
        } else if (k === 'instagram' && coins.insta == "1") {
            return 'claim';
        }
        return 'go';
    }

    const handleShareInfo = () => {
        setShowSharePopup(true);
        const timer = setTimeout(() => {
            setShowSharePopup(false);
        }, 3000);
        return () => clearTimeout(timer);
    };


    // Social shares
    const socials: Array<{ key: string; label: string; url: string }> = [
        { key: 'youtube', label: 'YouTube', url: 'https://www.youtube.com/@TheDramaFlicks_officially' },
        { key: 'facebook', label: 'Facebook', url: 'https://www.facebook.com/thedramaflicks.official' },
        { key: 'instagram', label: 'Instagram', url: 'https://www.instagram.com/thedramaflicks.official/' },
    ];



    return (
        <>
            {/* Notification item */}
            <div className={style.dfx_coinTaskList}>
                <div className={style.dfx_coinBonus}>
                    <div className={style.dfx_coinBonusContent}>
                        <div className={style.dfx_coinBonusdesc}>
                            {/* eslint-disable-next-line @next/next/no-img-element */}
                            <img src="/coinIg.webp" alt="coinIg" />
                        </div>
                        <div className={style.dfx_coinBonusInfo}>
                            <span className={style.dfx_coinBonusNumber}>{values.notificationReward} Bonus</span>
                            <p className={style.dfx_Notification}>Turn on Notifications</p>
                        </div>
                    </div>
                </div>
                {renderButton(coins.turn_on_web_notification === "1" ? 'claimed' : 'go', () => {
                    // Only open popup if not already claimed
                    if (coins.turn_on_web_notification !== "1") {
                        setNotifyEnabled(true);
                    }
                })}
            </div>

            {/* Email binding */}
            <div className={style.dfx_coinTaskList}>
                <div className={style.dfx_coinBonus}>
                    <div className={style.dfx_coinBonusContent}>
                        <div className={style.dfx_coinBonusdesc}>
                            {/* eslint-disable-next-line @next/next/no-img-element */}
                            <img src="/coinIg.webp" alt="email" />
                        </div>
                        <div className={style.dfx_coinBonusInfo}>
                            {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
                            <span className={style.dfx_coinBonusNumber}>{values.emailReward} Bonus</span>
                            <p className={style.dfx_Notification}>Bind Email</p>
                        </div>
                    </div>
                </div>
                {renderButton(coins.bindEmail === "1" ? 'claimed' : 'claim', () => { }, async () => {
                    const res = await addCoinData({ type: "add", bind_email: "1", coins: values.emailReward }, 'bindEmail').catch(() => { /* ignore errors */ });
                    // console.log(res)
                    if (res && res.ErrorCode === 1) {
                        setCoin({ bindEmail: "1", totalCoins: (coins.totalCoins + values.emailReward) });
                        onAward(values.emailReward);
                        window.scroll(0, 100);
                    }
                })}
            </div>

            {/* Social shares */}
            {socials.map((s) => {
                // Get the reward amount for this social platform
                const getRewardAmount = () => {
                    if (s.key === 'youtube') return values.shareYoutubeReward;
                    if (s.key === 'facebook') return values.shareFacebookReward;
                    if (s.key === 'instagram') return values.shareInstagramReward;
                    return 0;
                };

                // Get the store key name (yt, fb, insta)
                const getStoreKey = () => {
                    if (s.key === 'youtube') return 'yt';
                    if (s.key === 'facebook') return 'fb';
                    if (s.key === 'instagram') return 'insta';
                    return '';
                };

                const rewardAmount = getRewardAmount();
                const storeKey = getStoreKey();

                return (
                    <div className={style.dfx_coinTaskList} key={s.key as string}>
                        <div className={style.dfx_coinBonus}>
                            <div className={style.dfx_coinBonusContent}>
                                <div className={style.dfx_coinBonusdesc}>
                                    {/* eslint-disable-next-line @next/next/no-img-element */}
                                    <img src="/coinIg.webp" alt={s.label} />
                                </div>
                                <div className={style.dfx_coinBonusInfo}>
                                    <span className={style.dfx_coinBonusNumber}>{rewardAmount} Bonus</span>
                                    <p className={style.dfx_Notification}>{s.label=== 'YouTube' ? 'Subscribe' : 'Follow'} on {s.label}</p>
                                </div>
                            </div>
                        </div>
                        {renderButton(
                            socialbtn(s.key as string),
                            () => { 
                                // Open URL in new tab
                                window.open(s.url, '_blank');
                                // Update state to "1" (eligible to claim) after visiting
                                setCoin({ [storeKey]: "1" });
                            },
                            async () => {
                                // Prepare payload based on social platform
                                let payload: any = { type: "add", coins: rewardAmount };
                                if (s.key === 'youtube') {
                                    payload.subscribe_youtube = "1";
                                } else if (s.key === 'facebook') {
                                    payload.follow_facebook = "1"; // backend expects follow_facebook
                                } else if (s.key === 'instagram') {
                                    payload.follow_instagram = "1"; // backend expects follow_instagram
                                }

                                // Send API request to claim reward
                                const res = await addCoinData(payload, s.key as string).catch(() => { /* ignore errors */ });
                                if (res && res.ErrorCode === 1) {
                                    // Set local state to claimed (2) and add coins
                                    setCoin({ 
                                        [storeKey]: "2", 
                                        totalCoins: (coins.totalCoins + rewardAmount)
                                    });
                                    onAward(rewardAmount);
                                    window.scroll(0, 100);
                                }
                            }
                        )}
                    </div>
                );
            })}

            {/* Share with friends */}
            <div className={style.dfx_coinTaskList}>
                <div className={style.dfx_coinBonus}>
                    <div className={style.dfx_coinBonusContent}>
                        <div className={style.dfx_coinBonusdesc}>
                            {/* eslint-disable-next-line @next/next/no-img-element */}
                            <img src="/coinIg.webp" alt="share" />
                        </div>
                        <div className={style.dfx_coinBonusInfo}>
                            <span className={style.dfx_coinBonusNumber}>{values.friendShareReward} Bonus</span>
                            <p className={style.dfx_Notification}>Share with Friends
                                <span 
                                    className={style.dfx_shareWithfBtn}
                                    onClick={handleShareInfo}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none"><path d="M8.47144 0C3.79309 0 0 3.79309 0 8.47144C0 13.1509 3.79309 16.9429 8.47144 16.9429C13.1498 16.9429 16.9429 13.1509 16.9429 8.47144C16.9429 3.79309 13.1498 0 8.47144 0ZM9.23652 12.0877L9.3906 12.3688C9.3906 12.3688 8.70864 13.7057 7.56712 13.7057C6.96247 13.7057 6.65961 13.3198 6.65961 12.5483C6.65961 11.9961 6.80575 11.2125 7.09642 10.2007C7.38657 9.18622 7.5327 8.51486 7.5327 8.18394C7.5327 7.88691 7.39345 7.68678 7.11337 7.58406L7.19914 7.18378C7.19914 7.18378 8.19189 6.44624 8.93526 6.44624C9.46048 6.44624 9.7231 6.73056 9.7231 7.30133C9.7231 7.57559 9.60132 8.17124 9.35512 9.09039C9.15551 9.82688 9.00461 10.4294 8.90243 10.8959C8.81666 11.2787 8.7743 11.5413 8.7743 11.6848C8.7743 11.9532 8.92837 12.0877 9.23652 12.0877ZM9.12004 5.56468C8.47674 5.56468 7.95522 5.0458 7.95522 4.4025C7.95522 3.7592 8.47621 3.23715 9.12004 3.23715C9.76228 3.23715 10.2833 3.7592 10.2833 4.4025C10.2833 5.0458 9.76228 5.56468 9.12004 5.56468Z" fill="#8F8F8F"></path></svg>
                                </span>
                            </p>
                            {showSharePopup && (
                                <span className={style.dfx_Share_popup}>
                                    <p className={style.dfx_Share_popupContent}>Earn coins when you share. Limit: 3 per day.</p>
                                </span>
                            )}
                        </div>
                    </div>
                </div>
                {renderButton(
                    parseInt(coins.frindShare || "0") >= 3 ? 'claimed' : 'share',
                    () => {
                        // Reset share tracking and open modal
                        setHasShared(false);
                        setShowShareModal(true);
                        openShareModal({
                            id: '0',
                            d_id: '0',
                            drama_name: 'DramaFlicks',
                            d_name: 'DramaFlicks',
                            image_url: '/dramaflicksFeature.webp',
                            d_image: '/dramaflicksFeature.webp',
                            d_desc: 'Watch amazing short dramas on DramaFlicks!',
                            added_dt: new Date().toISOString(),
                            d_keywords: 'drama,short',
                            gradient: '',
                            slug: 'dramaflicks',
                            status: 'active',
                            total_episodes: '0',
                            unlock_epi_count: '0',
                            tag: 'featured',
                            type: 'short',
                            unlock_count: '0',
                            epi_num: '0',
                            total_d_stream: '0',
                        } as SliderDrama);
                    }
                )}
            </div>

            {/*Watch-duration tasks */}
            <div className={style.dfx_coinTaskList}>
                <div className={style.dfx_coinBonus}>
                    <div className={style.dfx_coinBonusContent}>
                        <div className={style.dfx_coinBonusdesc}>
                            {/* eslint-disable-next-line @next/next/no-img-element */}
                            <img src="/coinIg.webp" alt="watch10" />
                        </div>
                        <div className={style.dfx_coinBonusInfo}>
                            <span className={style.dfx_coinBonusNumber}>{values.watch10Reward} Bonus</span>
                            <p className={style.dfx_Notification}>Watch 10 minutes today</p>
                        </div>
                    </div>
                </div>
                {renderButton(
                    is10btn(),
                    () => router.push('/watchnow'),
                    async () => {
                        const res = await addCoinData({ type: "add", is10: "1", coins: values.watch10Reward }, 'watch10Minutes').catch(() => { /* ignore errors */ });
                        if (res && res.ErrorCode === 1) {
                            setCoin({ is10: "2", totalCoins: (coins.totalCoins + values.watch10Reward) });
                            onAward(values.watch10Reward);
                            window.scroll(0, 100);
                        }
                    }
                )}
            </div>

            <div className={style.dfx_coinTaskList}>
                <div className={style.dfx_coinBonus}>
                    <div className={style.dfx_coinBonusContent}>
                        <div className={style.dfx_coinBonusdesc}>
                            {/* eslint-disable-next-line @next/next/no-img-element */}
                            <img src="/coinIg.webp" alt="watch20" />
                        </div>
                        <div className={style.dfx_coinBonusInfo}>
                            <span className={style.dfx_coinBonusNumber}>{values.watch20Reward} Bonus</span>
                            <p className={style.dfx_Notification}>Watch 20 minutes today</p>
                        </div>
                    </div>
                </div>
                {renderButton(
                    is20btn(),
                    () => router.push('/watchnow'),
                    async () => {
                        const res = await addCoinData({ type: "add", is20: "1", coins: values.watch20Reward }, 'watch20Minutes').catch(() => { /* ignore errors */ });
                        if (res && res.ErrorCode === 1) {
                            setCoin({ is20: "2", totalCoins: (coins.totalCoins + values.watch20Reward) });
                            onAward(values.watch20Reward);
                            window.scroll(0, 100);
                        }
                    })}
            </div>
            {notifyEnabled && coins.turn_on_web_notification !== "1" && <EnableNotification 
                onClose={() => setNotifyEnabled(false)} 
                onEnable={async () => {
                    try {
                        // Permission should already have been requested when modal opened.
                        if (typeof Notification === 'undefined' || Notification.permission !== 'granted') {
                            setNotifyEnabled(false);
                            return;
                        }

                        // Use existing cached token if present (no extra fetch unless already cached)
                        const fcmToken = typeof window !== 'undefined' ? (localStorage.getItem('fcm_token') || '') : '';
                        if (!fcmToken) {
                            console.warn('FCM token missing; user granted permission but token not yet cached.');
                        }

                        // Call API to claim reward
                        const res = await addCoinData(
                            { type: "add", turn_on_web_notification: "1", coins: values.notificationReward },
                            'notification'
                        ).catch(() => { /* ignore errors */ });
                        
                        if (res && res.ErrorCode === 1) {
                            // Update store with claimed state and reward
                            setCoin({ 
                                turn_on_web_notification: "1", 
                                totalCoins: (coins.totalCoins + values.notificationReward) 
                            });
                            // Show reward popup
                            onAward(values.notificationReward);
                            // Close popup
                            setNotifyEnabled(false);
                            window.scroll(0, 100);
                        } else {
                            setNotifyEnabled(false);
                        }
                    } catch (err) {
                        console.warn('Notification enable flow failed:', err);
                        setNotifyEnabled(false);
                    }
                }} 
                amount={values.notificationReward} 
            />}
            {showShareModal && (
                <ShareModalHandler
                    hasShared={hasShared}
                    onShare={() => setHasShared(true)}
                    onClose={async () => {
                        // Only reward if user shared before closing
                        if (!hasShared) {
                            setShowShareModal(false);
                            return;
                        }

                        // Get current share count
                        const currentCount = parseInt(coins.frindShare || "0");
                        if (currentCount >= 3) {
                            setShowShareModal(false);
                            return; // Already completed 3 shares
                        }

                        // Increment share count
                        const newCount = currentCount + 1;
                        
                        // Call API to reward coins
                        const res = await addCoinData(
                            { type: "add", share_with_friends: "1", coins: values.friendShareReward },
                            'shareWithFriends'
                        ).catch(() => { /* ignore errors */ });
                        
                        if (res && res.ErrorCode === 1) {
                            // Update store with new count and total coins
                            setCoin({ 
                                frindShare: newCount.toString(), 
                                totalCoins: (coins.totalCoins + values.friendShareReward) 
                            });
                            onAward(values.friendShareReward);
                            // Close modal
                            setShowShareModal(false);
                            const { closeShareModal: closeModal } = useShareModalStore.getState();
                            closeModal();
                            // Scroll to show updated coins
                            window.scroll(0, 100);
                        }
                    }}
                />
            )}
        </>
    );
}

// Component to handle share modal interactions
function ShareModalHandler({ hasShared, onShare, onClose }: { hasShared: boolean; onShare: () => void; onClose: () => void }) {
    const { isOpen, closeShareModal } = useShareModalStore();

    React.useEffect(() => {
        // When modal closes, trigger onClose callback
        if (!isOpen) {
            onClose();
        }
    }, [isOpen, onClose]);

    const handleCloseModal = () => {
        closeShareModal();
    };

    return (
        <div onClick={handleCloseModal}>
            <ShareModal onShare={onShare} />
        </div>
    );
}
